import { render, staticRenderFns } from "./SetsRound.vue?vue&type=template&id=d2d593d8&scoped=true&"
import script from "./SetsRound.vue?vue&type=script&lang=js&"
export * from "./SetsRound.vue?vue&type=script&lang=js&"
import style0 from "./SetsRound.vue?vue&type=style&index=0&id=d2d593d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d593d8",
  null
  
)

export default component.exports